import { DeviceGroupList, DeviceTypeList } from 'components';
import BaseAccordion from 'components/Accordions/BaseAccordion';
import { useGetAllAvailableDeviceTypesQuery } from 'services/devices/devices.api';

const DeviceListAccordion = ({
  showGroups,
  onOpenDevice,
  visibleDeviceTypes,
  widget = false,
  deviceTypes = null,
}) => {
  const { data: integrationDeviceTypes = {} } = useGetAllAvailableDeviceTypesQuery();
  const resolvedDeviceTypes = integrationDeviceTypes || deviceTypes;

  if (showGroups) {
    return (
      <div className="d-block d-lg-none">
        {/* Mobile-only: accordion replaces the desktop table view. */}
        <BaseAccordion header="Groups" bodyBackground="#232B33">
          <DeviceGroupList
            onOpenDevice={onOpenDevice}
            visibleDeviceTypes={visibleDeviceTypes}
            widget={widget}
            deviceAccordion
          />
        </BaseAccordion>
      </div>
    );
  }

  return (
    <div className="d-block d-lg-none">
      {resolvedDeviceTypes &&
        typeof resolvedDeviceTypes === 'object' &&
        Object.keys(resolvedDeviceTypes).map((key) => (
          <div className="mb-3" key={key}>
            <BaseAccordion
              bodyBackground="#232B33"
              header={<div className="fw-semibold">{key.replace('_', ' ')}</div>}
            >
              {/* Render device rows as accordions on mobile for density. */}
              <DeviceTypeList
                type={resolvedDeviceTypes[key]}
                name={key}
                onOpenDevice={onOpenDevice}
                hideHeader
                deviceAccordion
                widget={widget}
              />
            </BaseAccordion>
          </div>
        ))}
    </div>
  );
};

export default DeviceListAccordion;
